@if (localeContentStatus) {
  <div class="rc-order-status rc-order-status--{{ localeContentStatus.code }}">
    <em class="rc-order-status__icon rc-icon rc-icon--{{ localeContentStatus.code }}"></em>
    <span class="rc-order-status__text">{{ localeContentStatus.localizedText }}</span>
  </div>
} @else {
  <em class="rc-order-status__icon rc-icon"></em>
  <span class="rc-order-status__text">--</span>
}
